var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 7.918,
    y: 398.515,
    style: {
      fill: "#AFB6BB"
    },
    width: 496.165,
    height: 84.454
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00A651"
    },
    points: "504.082,261.278 504.082,356.289 319.024,240.587 319.34,240.165 393.237,182.103 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#36C63F"
    },
    points: "504.082,356.289 504.082,398.515 7.918,398.515 7.918,324.619 250.722,197.938  319.024,240.587 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#009DD3"
    },
    points: "504.082,29.031 504.082,261.278 393.237,182.103 319.34,240.165 319.024,240.587  250.722,197.938 7.918,324.619 7.918,29.031 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0086BE"
    },
    points: "7.918,29.031 7.918,324.619 250.722,197.938 256,201.234 256,29.031 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#009547"
    },
    points: "504.082,307.311 353.901,213.01 319.34,240.165 319.024,240.587 504.082,356.289 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00AC4E"
    },
    points: "504.082,356.289 319.024,240.587 250.722,197.938 213.415,217.403 504.082,398.088 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD311"
    },
    d: "M124.041,76.536c34.943,0,63.34,28.398,63.34,63.34s-28.398,63.34-63.34,63.34 s-63.34-28.398-63.34-63.34S89.099,76.536,124.041,76.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABB1B"
    },
    d: "M99.201,81.814c-22.619,9.674-38.5,32.132-38.5,58.259c0,34.943,28.398,63.34,63.34,63.34 c20.289,0,38.325-9.612,49.923-24.481C138.199,157.279,111.139,122.842,99.201,81.814z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,21.113v469.773h512V21.113H0z M496.165,342.001l-163.51-102.229l60.808-47.778l102.702,73.359V342.001z M496.165,36.948 v208.945l-103.154-73.682L318.38,230.85l-67.305-42.026L15.835,311.557V36.948H496.165z M496.165,475.052H15.835v-68.619h480.33 V475.052z M15.835,390.598v-61.18l234.534-122.366l64.458,40.247l181.338,113.377v29.922H15.835z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.041,211.134c39.292,0,71.258-31.966,71.258-71.258s-31.966-71.258-71.258-71.258s-71.258,31.966-71.258,71.258 S84.749,211.134,124.041,211.134z M124.041,84.454c30.561,0,55.423,24.862,55.423,55.423s-24.862,55.423-55.423,55.423 s-55.423-24.862-55.423-55.423S93.481,84.454,124.041,84.454z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.588,
    y: 432.825,
    style: {
      fill: "#FFFFFF"
    },
    width: 258.639,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.062,
    y: 432.825,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.392,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.289,
    y: 432.825,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.392,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.515,
    y: 432.825,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.392,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.995,
    y: 287.682,
    transform: "matrix(-0.8548 -0.519 0.519 -0.8548 478.0404 724.9606)",
    style: {
      fill: "#FFFFFF"
    },
    width: 172.901,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.387,
    y: 250.722,
    transform: "matrix(-0.8575 -0.5145 0.5145 -0.8575 661.1055 700.394)",
    style: {
      fill: "#FFFFFF"
    },
    width: 92.33,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.887,
    y: 79.175,
    style: {
      fill: "#FFFFFF"
    },
    width: 137.237,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.237,
    y: 79.175,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.392,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.67,
    y: 121.402,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.392,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.443,
    y: 121.402,
    style: {
      fill: "#FFFFFF"
    },
    width: 26.392,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.897,
    y: 121.402,
    style: {
      fill: "#FFFFFF"
    },
    width: 131.959,
    height: 15.835
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image_icon.894d8f1a3e632d17f5dab39cd6ea6720.svg";
export { ForwardRef as ReactComponent };